import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { OutboxSync } from "./components/OutboxSync";
import { ToastProvider } from "./components/Toast";
import { I18nProvider } from "./i18n";
import { AuthProvider } from "./lib/AuthContext";
import { ThemeProvider } from "./lib/theme";

export function makeQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });
}

export function Providers({ children, router = true }: { children: ReactNode; router?: boolean }) {
  const [qc] = useState(makeQueryClient);
  const inner = (
    <QueryClientProvider client={qc}>
      <I18nProvider>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <OutboxSync />
              {children}
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </I18nProvider>
    </QueryClientProvider>
  );
  return router ? <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>{inner}</BrowserRouter> : inner;
}
